import { toast } from 'react-toastify';

export const successToast = (msg) =>
    toast.success(msg, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    }); 
    
export const errorToast = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

// Something the operator must act on (e.g. a label to take off a box): it
// stays until closed instead of fading after five seconds.
export const warningToast = (msg) =>
        toast.warning(msg, {
            position: "top-center",
            autoClose: false,
            closeOnClick: true,
            draggable: true,
            theme: "light",
        });
